/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconNumber6 = createReactComponent("number-6", "IconNumber6", [
  ["path", { d: "M8 16a4 4 0 1 0 8 0v-1a4 4 0 1 0 -8 0", key: "svg-0" }],
  ["path", { d: "M16 8a4 4 0 1 0 -8 0v8", key: "svg-1" }]
]);

export { IconNumber6 as default };
//# sourceMappingURL=IconNumber6.js.map
